import { MainTabNav } from "~/components/MainTabNav"

type LoggedInScreenCardProps = {
  children: React.ReactNode
}

/**
 * Frosted shell shared by logged-in screens. MainTabNav is fixed to the
 * viewport so it stays visible while content scrolls.
 */
export function LoggedInScreenCard({ children }: LoggedInScreenCardProps) {
  return (
    <>
      <div className="w-full rounded-2xl bg-[var(--color-surface-card)]/60 p-4 pb-6 shadow-sm backdrop-blur-sm">
        {children}
      </div>
      <MainTabNav />
    </>
  )
}
